/* eslint-disable */
import React from "react"

export default function Cta({ href, text, type, targetBlank }) {
  return (
    <a
      href={href}
      className={`cta cta--${type}`}
      target={targetBlank ? "_blank" : null}
      rel={targetBlank ? "noreferrer" : null}
    >
      {text}
      {type === "secondary" ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
        >
          <path
            d="M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z"
            fill="currentColor"
          />
        </svg>
      ) : null}
    </a>
  )
}
